import moment from 'moment';
let startMonth = moment().subtract(1, 'years').format('YYYY-MM');
let endMonth = moment().format('YYYY-MM');
export default {
	searchParams: {
		carCd: null,
		selRowCarCd: null,
		startMonth: startMonth,
		endMonth: endMonth
	},
	cpnyPopup: CPNY_POPUP(),
	grdSalesList: [], //그리드리스트
	carCdList: [], //검색에서 사용하는 차종
	gridCarList: [], //그리드 안에 차종(셀렉트박스인데 isDisabled처리)
	dayCols: [], //그리드 컬럼(년월컬럼)
	graphPieResultList: [], //그래프파이 임시저장소
	graphBarStackChartInfo: [], //그래프 스택 임시저장소
	graphLineChartInfo: [], //라인차트 임시저장소
	graphMixedChartInfo: [], //바라인차트
	// 사용자 공통팝업 파라미터 정보
	searchPartPopParams: {
		//검색할 데이터 파라미터로 정의
		partNo: ''
	}
};
function CPNY_POPUP() {
	return {
		cpnyCd: '',
		cpnyNm: '',
		partNm: '',
		usePrd: '',
		milg: '',
		rtsh: '',
		partNo: ''
	};
}
